import { render, staticRenderFns } from "./BotaoVirtualizar.vue?vue&type=template&id=c5a43992&scoped=true"
import script from "./BotaoVirtualizar.vue?vue&type=script&lang=js"
export * from "./BotaoVirtualizar.vue?vue&type=script&lang=js"
import style0 from "./BotaoVirtualizar.vue?vue&type=style&index=0&id=c5a43992&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a43992",
  null
  
)

export default component.exports